// Yellow Flag: its list that opens by address. No React in here.
//
// Flags raised counts FLAGS, one row each: a person flagged three times is three rows,
// because the month's number beside the chart (and on the home screen's card) counts
// three. It follows the Month picker and every filter on the dashboard, as that number
// does. Not "Yellow flags raised": that is the chart's name, and a list has a name of
// its own.
import type { DashboardListInfo } from './types';

export const YELLOW_FLAG_LIST = { raised: 'raised' } as const;

export const LISTS: DashboardListInfo[] = [
  {
    slug: YELLOW_FLAG_LIST.raised,
    name: 'Flags raised',
    line: 'Every standing yellow flag (open or upheld) raised in the month you pick, one row each, with who raised it and why.',
    keywords: 'raised this month warning store visit',
  },
];
